/*!
 *
 *  Copyright (c) "Neo4j"
 *  Neo4j Sweden AB [http://neo4j.com]
 *
 *  This file is part of Neo4j.
 *
 *  Neo4j is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

// THIS FILE IS GENERATED BY BUILD TOOL
// DO NOT EDIT IT MANUAL
import { wrapIcon } from '../../wrapIcon';
import { SVGProps } from 'react';
const SvgOpenQueryTabBase = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 8.49333H9.55556M2 8.49333L2 4C2 3.4 2.35556 3 2.88889 3H9.55556M2 8.49333V15.5M22 8.49333H9.55556M22 8.49333V20C22 20.6 21.6444 21 21.1111 21H9.55556M22 8.49333V4C22 3.4 21.6444 3 21.1111 3H9.55556M9.55556 8.49333V3M10 13H5.85185M10 13V17.1481M10 13L2 21"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
/** @deprecated Use `FloppyDiskArrowTopRightIcon` instead. */
const SvgOpenQueryTab = wrapIcon(SvgOpenQueryTabBase);
export default SvgOpenQueryTab;
